import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyBj5oYvYDTOpFeYUrZIqrPTieFMXQgN8j8",
  authDomain: "awesome-dia-9b112.firebaseapp.com",
  projectId: "awesome-dia-9b112",
  storageBucket: "awesome-dia-9b112.firebasestorage.app",
  messagingSenderId: "205286726344",
  appId: "1:205286726344:web:083836561dd4eb8060e3fd",
  measurementId: "G-01HX2JRVDR"
};

// Initialize Firebase App
const firebaseApp = initializeApp(firebaseConfig);

// Initialize messaging with error handling
let messaging = null;
try {
  messaging = getMessaging(firebaseApp);
  console.log('Firebase Messaging initialized successfully');
} catch (error) {
  console.error('Error initializing Firebase Messaging:', error);
  // Don't throw the error, just log it
}

// Helper function to safely get messaging instance
export const getMessagingInstance = () => {
  if (!messaging) {
    throw new Error('Firebase Messaging is not available in this browser');
  }
  return messaging;
};

// Export messaging and functions with safety checks
export { messaging, getToken, onMessage };

// Export a function to check if messaging is available
export const isMessagingAvailable = () => messaging !== null;